<template>
  <v-form @submit.prevent="submit">
    <label class="input-label mb-2 ml-2">Osoba</label>
    <v-select
      v-model="userId"
      v-bind="props.select"
      :items="availableUsers"
      :rules="[rules.required]"
      item-value="id"
      :item-text="fullName"
      placeholder="Wybierz osobę"
      class="mb-4"
    />
    <v-btn
      color="primary"
      depressed
      type="submit"
      :disabled="!userId || isSubmitting"
      :loading="isSubmitting"
    >
      Dodaj
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    listType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      props,
      rules,
      userId: null,
      isSubmitting: false,
    };
  },
  computed: {
    ...mapState('dkoCooperation', ['candidates', 'request']),
    availableUsers() {
      const taken = new Set((this.request?.[this.listType] || []).map((member) => member.userId));
      return this.candidates.filter((user) => !taken.has(user.id));
    },
  },
  created() {
    this.fetchCandidates();
  },
  methods: {
    ...mapActions('dkoCooperation', ['fetchCandidates', 'createMember']),
    fullName(user) {
      return `${user.firstName} ${user.lastName}`;
    },
    submit() {
      if (!this.userId || this.isSubmitting) return;
      this.isSubmitting = true;
      this.createMember({ userId: this.userId, listType: this.listType })
        .catch(() => {})
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
